export default "__VITE_ASSET__x_zzjk0o__"